import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VbImageLoadDirective } from '../../shared/VbImageLoad.Directive';

import { VgPosterComponent } from './VgPoster.Component';

const components = [
	VgPosterComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		VbImageLoadDirective
	]
})
export class VgPosterModule {}
